module.exports = __webpack_public_path__ + "img/icon-worklist.10f27a3c.svg";